<div class="navbar-toggle" (click)="toggleCollapse()" [ngClass]="{ 'floating': floating }">
  <i class="fa fa-bars"></i>
</div>
<nav class="navbar">
  <ng-content></ng-content>
</nav>
